import {SET_ADOBE_READY_FLAG, SET_BRAND, SET_PATH_NAME, SET_SERVER, TOGGLE_OFF_FIRST_LOAD} from "./ActionTypes";

const initialState = {
    brand: '',
    loadingServer: '',
    pathname: '',
    adobeScriptLoadFlag: false,
    firstLoadFlag: true,
};

const appParamsReducer = (state = initialState, action) => {
    if (action.payload) {
        switch (action.type) {
            case SET_BRAND: {
                return Object.assign({}, state, {
                    newState: (state.brand= action.payload),
                });
            }
            case SET_SERVER: {
                return Object.assign({}, state, {
                    newState: (state.loadingServer = action.payload),
                });
            }
            case SET_PATH_NAME: {
                return Object.assign({}, state, {
                    newState: (state.pathname = action.payload),
                });
            }
            case SET_ADOBE_READY_FLAG: {
                return ({
                    ...state,
                    adobeScriptLoadFlag: action.payload.flag
                })
            }
            case TOGGLE_OFF_FIRST_LOAD: {
                return {
                    ...state,
                    firstLoadFlag: false
                }
            }
            default:
                return state;
        }
    } else {
        return state;
    }
}

export default appParamsReducer;
